@if (tableStyle) {
    <textarea
        [formControl]="fc"
        [name]="field.name"
        [placeholder]="field.name"
        matInput
        cdkTextareaAutosize
        rows="1"></textarea>
} @else {
    <mat-form-field class="w-100 h-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
        <mat-label>{{ field.name }}</mat-label>
        <textarea [formControl]="fc" [name]="field.name" [placeholder]="field.name" matInput rows="4"></textarea>
        <mat-error [control]="fc"></mat-error>
    </mat-form-field>
}
